import api from '@/utils/api';

const { baseApi } = window.GlobalConfig;

export const QueryCustomerBudget = data => {
    return api.post(`${baseApi}/incomeBudget/getIncomeBudgetPage`, data);
};

export const AdjustBudget = data => {
    return api.post(`${baseApi}/incomeTargetCustomer/updateIncomeTargetCustomerByPrepare`, data);
};

export const QueryDevelopBudget = ({ customerId, year }) => {
    return api.get(`${baseApi}/incomeBudgetDevelop/getIncomeBudgetDevelop/${year}/${customerId}`);
};

export const SaveDevelopBudget = data => {
    return api.post(`${baseApi}/incomeBudgetDevelop/saveIncomeBudgetDevelop`, data);
};

export const QueryInceraseBudget = data => {
    return api.post(`${baseApi}/incomeBudgetIncreaseItem/getIncomeBudgetIncreaseItemByCustomer`, data);
};

export const QueryIncomeActual = ({ medicalItemId, customerId, year }) => {
    return api.get(`${baseApi}/incomeActual/getIncomeActual/${customerId}/${year}/${medicalItemId}`);
};

export const SaveIncreaseBudget = data => {
    return api.post(`${baseApi}/incomeBudgetIncreaseItem/saveIncomeBudgetIncreaseItem`, data);
};

export const UpdateCustomerYearTarget = data => {
    return api.post(`/incomeTargetCustomerYear/saveIncomeTargetCustomerYear`, data);
};
// 带入指标
export const RefreshTarget = data => {
    return api.post(`/incomeTargetCustomer/updateIncomeTargetCustomerByIncome`, data);
};

export const RefreshTargetYear = data => {
    return api.post(`/incomeTargetCustomerYear/updateIncomeTargetCustomerYearByIncome`, data);
};

export const MarkMonthAll = data => {
    return api.post(`/incomeTargetCustomerYear/updateIncomeTargetCustomerYearByMonth`, data);
};
